import { render, staticRenderFns } from "./big_package.vue?vue&type=template&id=169fbe31"
import script from "./big_package.vue?vue&type=script&lang=js"
export * from "./big_package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports